import { useEffect } from 'react'

/**
 * Reaplica el salto al fragmento de la URL en una carga en frío.
 *
 * Al ser una SPA, el navegador procesa el `#seccion` cuando el documento
 * todavía está vacío: no encuentra el elemento y deja el scroll arriba. Quien
 * abre un enlace compartido a `/#catalogo` aterriza en el hero. Al montar el
 * componente la sección ya existe, así que se repite el salto aquí.
 *
 * La navegación interna del menú no pasa por esto: cuando se pulsa un enlace
 * el DOM ya está montado y el navegador resuelve el ancla solo.
 *
 * `activo` reengancha el mismo salto al volver a esta página desde otra ruta
 * (p. ej. desde el detalle de un producto hacia "/#catalogo" vía `Enlace`):
 * ahí tampoco existía la sección en el momento del clic.
 *
 * El desfase del encabezado fijo lo aporta `scroll-padding-top` en index.css.
 */
export function useAnclaInicial(activo = true) {
  useEffect(() => {
    if (!activo) return

    const { hash } = window.location
    if (!hash || hash === '#') return

    let destino
    try {
      destino = document.querySelector(hash)
    } catch {
      // Un fragmento que no es un selector CSS válido no es un error nuestro.
      return
    }

    // Instantáneo a propósito: un desplazamiento suave desde el inicio de la
    // página hasta el pie recorrería todas las secciones y se ve como un fallo.
    destino?.scrollIntoView({ behavior: 'instant', block: 'start' })
  }, [activo])
}
